import request from '@/utils/request'

// 获取项目列表
export function getProjectList(data) {
  return request({
    url: '/admin/operate/webManager/list',
    method: 'post',
    data
  })
}

// 添加项目
export function addProject(data) {
  return request({
    url: '/admin/operate/webManager/add',
    method: 'post',
    data
  })
}

// 修改项目
export function updateProject(data) {
  return request({
    url: '/admin/operate/webManager/edit',
    method: 'post',
    data
  })
}
// 项目排序
export function sortProject(data) {
  return request({
    url: '/admin/operate/webManager/sortEdit',
    method: 'post',
    data
  })
}

// 删除项目
export function removeProject(data) {
  return request({
    url: '/admin/operate/webManager/remove',
    method: 'post',
    data
  })
}
